import React from 'react';
import { CalendarCheckIcon, CheckIcon } from 'lucide-react';
import { barberOrder, barbers } from '../data/business';
import { useLanguage } from '../contexts/LanguageContext';
import { useBooking } from '../contexts/BookingContext';
export function Barbers() {
  const {
    t
  } = useLanguage();
  const {
    barberId,
    bookWithBarber
  } = useBooking();
  return <section id="barberos" className="w-full bg-ink py-20 lg:py-28" data-id="element-41" data-mp="2j5qo89j6tpky">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-42" data-mp="25795yrc1x5af">
        <div className="max-w-2xl" data-id="element-43" data-mp="299dxnkixvruf">
          <p className="mb-4 text-xs uppercase tracking-[0.28em] text-gold" data-id="element-44" data-mp="29af8pozygec5">{t.barbers.eyebrow}</p>
          <h2 className="font-display text-3xl font-bold uppercase leading-tight text-cream sm:text-4xl lg:text-[2.9rem]" data-id="element-45" data-mp="1vb62ni5gr0lw">
            {t.barbers.title}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-cream/75 lg:text-lg" data-id="element-46" data-mp="3pndtokenyxce">
            {t.barbers.intro}
          </p>
        </div>

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-47" data-mp="3umgnf8p71h52">
          {barberOrder.map(id => {
          const barber = barbers[id];
          const selected = barberId === id;
          return <li key={id} data-id="element-48" data-mp="keqqwxpah4j1">
                <button type="button" onClick={() => bookWithBarber(id)} aria-pressed={selected} className={`group flex w-full flex-col overflow-hidden rounded-sm border bg-panel text-left transition-colors duration-150 ease-out ${selected ? 'border-gold' : 'border-white/10 hover:border-gold/60'}`} data-id="element-49" data-mp="y7zwsoe137wt">
                  <span className="relative block" data-id="element-50" data-mp="fit72hethg1i">
                    <img src={barber.image} alt={`${barber.name} — ${t.barbers.roles[id]}`} loading="lazy" className="aspect-square w-full bg-black object-contain" data-id="element-51" data-mp="ffdv3ngfwn4b" />
                    <span className={`absolute right-3 top-3 flex items-center gap-1.5 rounded-sm px-2.5 py-1 font-display text-[11px] font-semibold uppercase tracking-wider transition-colors duration-150 ease-out ${selected ? 'bg-gold text-ink' : 'bg-ink/85 text-gold'}`} data-id="element-52" data-mp="1lxkhbbptyd87">
                      {selected && <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-53" data-mp="xiw1s44p86k4" />}
                      {selected ? t.barbers.selected : t.barbers.tapHint}
                    </span>
                  </span>

                  <span className="flex flex-1 flex-col p-5" data-id="element-54" data-mp="4wb6wtp0lcbt">
                    <span className="font-display text-xl font-semibold uppercase tracking-wide text-cream" data-id="element-55" data-mp="9u31jvh1ncjp">
                      {barber.name}
                    </span>
                    <span className="mt-1 text-sm text-cream/60" data-id="element-56" data-mp="en5z0eoxz656">{t.barbers.roles[id]}</span>
                    <span className={`mt-5 flex items-center justify-center gap-2 rounded-sm px-4 py-3 font-display text-sm font-semibold uppercase tracking-wider transition-colors duration-150 ease-out ${selected ? 'bg-gold text-ink' : 'border border-gold/40 text-gold group-hover:bg-gold group-hover:text-ink'}`} data-id="element-57" data-mp="3d9h5vm2txmkd">
                      <CalendarCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-58" data-mp="2wqcf36a6cwmu" />
                      {t.barbers.bookWith} {barber.name}
                    </span>
                  </span>
                </button>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}